import { render } from "./TreeItem.vue?vue&type=template&id=6681fc0b&scoped=true"
import script from "./TreeItem.vue?vue&type=script&lang=js"
export * from "./TreeItem.vue?vue&type=script&lang=js"

import "./TreeItem.vue?vue&type=style&index=0&id=6681fc0b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6681fc0b"]])

export default __exports__